export const GET_ZONE_MAPPING_SUCCESS = 'GET_ZONE_MAPPING_SUCCESS';
export const GET_ZONE_MAPPING_REQUEST = 'GET_ZONE_MAPPING_REQUEST';
export const GET_ZONE_MAPPING_FAILURE = 'GET_ZONE_MAPPING_FAILURE';
export const GET_ZONE_MAPPING_REST = 'GET_ZONE_MAPPING_REST';
export const getZoneMappingSuccess = (payload) => ({
    type: GET_ZONE_MAPPING_SUCCESS,
    payload,
});
export const getZoneMappingRequest = (payload) => ({
    type: GET_ZONE_MAPPING_REQUEST,
    payload,
});
export const getZoneMappingFailure = (payload) => ({
    type: GET_ZONE_MAPPING_FAILURE,
    payload,
});
export const getZoneMappingRest = () => ({
    type: GET_ZONE_MAPPING_REST,
});
